import { type FC, useCallback } from 'react';
import { batch } from 'react-redux';

import { boundActionsFactory } from '@/packages/redux-state/store';
import { useMapControlsIsCurrentAreaSearchActiveSelector } from '@/packages/redux-state/store/slices/mapControls';

import { useMapStoreContext } from '../../../context/mapStoreContext';

import { CurrentAreaSearch } from './CurrentAreaSearch';
import { trackCurrentAreaSearch } from './internal/tracking';

const useBoundActions = boundActionsFactory(reduxActions => ({
  setIsCurrentAreaSearchActive: reduxActions.mapControls.setIsCurrentAreaSearchActive,
  setSelectedBounds: reduxActions.mapControls.setSelectedBounds,
  setViewMode: reduxActions.listingLayout.setViewMode,
}));

export const CurrentAreaSearchContainer: FC = () => {
  const boundActions = useBoundActions();
  const { map } = useMapStoreContext();

  const handleClick = useCallback(() => {
    batch(() => {
      boundActions.setIsCurrentAreaSearchActive(false);
      boundActions.setSelectedBounds(map.getBounds());
      boundActions.setViewMode('hybrid');
    });

    trackCurrentAreaSearch();
  }, [boundActions, map]);

  const isVisible = useMapControlsIsCurrentAreaSearchActiveSelector();

  if (!isVisible) {
    return null;
  }

  return <CurrentAreaSearch handleClick={handleClick} />;
};
